var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gray-bg conciliacao-embed-wrapper",attrs:{"id":"page-wrapper"}},[_c('div',{staticClass:"wrapper-content animated fadeIn"},[_c('router-view')],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cce20ba2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./FrontEnd/componentes/LayoutConciliacaoEmbed.vue
// module id = 2312
// module chunks = 0